import { Environment } from './environment.interface';

export const environment: Environment = {
    production: false,
    brand: 'maptheday',
    basePath: 'https://www.joblaundry-apigateway.com/apigateway',
    // basePath: 'https://localhost:7222/apigateway',
    tocVersion: '1.0.1',
    firebase: {
        apiKey: "AIzaSyDaZL4Qdjp_jQ6JjDtK2JcHZJe-CcJU33k",
        authDomain: "map-the-day.firebaseapp.com",
        projectId: "map-the-day",
        storageBucket: "map-the-day.firebasestorage.app",
        messagingSenderId: "373418647686",
        appId: "1:373418647686:web:34e774eb28e5ff40e0f107"
    }
};